import React, { useState, useRef } from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import { NavLink, useHistory } from 'react-router-dom';
import CardContent from '@material-ui/core/CardContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Modal from '../Modals/Modal';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import { useMediaQuery, createStyles, makeStyles } from '@material-ui/core';
import { themeButtons } from '../../../css/themeButtons';
import Access2Object from '../Access2Object/Access2ObjectContainer';
import { useUserVerified } from '../../../App';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      transition: '.25s',
      backgroundColor: '#f6f6f6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&:hover': {
        backgroundColor: '#ebebeb',
      },

      '&:not(:last-child)': {
        borderBottom: '1px solid #ebebeb',
      },

      '@media (max-width: 425px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    btn: {
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      flex: '0 0 auto',
      marginStart: '.5rem',

      '@media (max-width: 425px)': {
        margin: '0',
      },
    },
  })
);

const PreviewObjects = ({ objects }) => {
  const classes = useStyles();

  const firstThree = [];
  if (objects && Object.keys(objects).length !== 0) {
    for (let i = 0; i < 3; i++) {
      if (Object.values(objects)[i]) {
        firstThree.push(
          <ListItem className={classes.root}>
            <span>{Object.values(objects)[i].name}</span>
            <Button
              className={`btn ${classes.btn}`}
              component={NavLink}
              to={`/lk/${Object.values(objects)[i].id}`}
            >
              <FontAwesomeIcon icon={['far', 'edit']} className='me-1' />
              Смотреть/изменить
            </Button>
          </ListItem>
        );
      }
    }
  }

  if (!objects) {
    return <></>;
  }
  return (
    <>
      <Typography variant='h6' component='h6' className='mb-0 mt-2'>
        Ваши объекты:
      </Typography>

      <List
        component='nav'
        className='pt-0'
        aria-label='secondary mailbox folders'
      >
        {firstThree}
      </List>

      {objects &&
        Object.keys(objects).length > 3 &&
        `и ещё ${Object.keys(objects).length - 3} объектов`}
    </>
  );
};

const ObjectsTable = ({ objects, moderator, children }) => {
  const history = useHistory();
  const mobileAgent = useMediaQuery('(max-width: 974px)');
  const [confirmRedirectModal, setConfirmRedirectModal] = useState(false);
  const [showGetAccess2ObjectModal, setShowGetAccess2ObjectModal] =
    useState(false);

  const redirectToAddObject = () => {
    history.push('/lk/newObject');
  };

  const userVirified = useUserVerified();
  const formRef = useRef();
  const sendGetAccess2ObjectRequest = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    } else {
      setShowGetAccess2ObjectModal(false);
    }
  };

  const handelClickGetAccess2Object = () => {
    setShowGetAccess2ObjectModal(true);
  };

  const handelClickAddObject = () => {
    if (!objects) {
      return redirectToAddObject();
    }
    setConfirmRedirectModal(true);
  };

  const buttons = themeButtons();

  let mobileElements = [];
  let addBtn = <></>;
  let helpText = <></>;
  let getAccess2ObjectBtn = <></>;

  if (!moderator) {
    addBtn = (
      <div className='col'>
        <Card className='card add-card card-object'>
          <CardActionArea
            component={Button}
            onClick={handelClickAddObject}
            className='d-flex w-100 h-100'
          >
            <CardContent className={'add-object__icon'}>
              <FontAwesomeIcon icon='plus' size='lg' />
            </CardContent>
            <CardContent>
              <Typography className='add-object__text text-center' variant='h6'>
                Добавить новый объект
              </Typography>
              <Typography
                className='add-object__text text-center justify-content-center'
                variant='h7'
              >
                (гостиницу/квартиру/дом)
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </div>
    );
    helpText = (
      <Card className='card add-card card-object'>
        <CardContent>
          <div className='mb-3'>
            <Typography className='' variant='h6'>
              Как добавить новую гостиницу/квартиру/дом?
            </Typography>
            <Typography variant='body1'>
              Для того, чтобы добавить новую гостиницу/квартиру/дом нажмите на
              кнопку "Добавить новый объект"
            </Typography>
          </div>
          <Button
            className={`mb-2 btn ${buttons.btnWarn}`}
            onClick={handelClickGetAccess2Object}
          >
            <FontAwesomeIcon icon='question-circle' className='me-1' />
            Уже есть объект на Едем-в-Гости.ру?
          </Button>
          <div className='mb-3'>
            <Typography className='' variant='h6'>
              Как изменить информацию о гостинице/квартире/доме?
            </Typography>
            <Typography variant='body1'>
              Найдите необходимую гостиницу/квартиру/дом в списке Ваших объектов
              и нажмите на кнопку "Смотреть/Изменить"
            </Typography>
          </div>
          <div className='mb-3'>
            <Typography className='' variant='h6'>
              Как добавить новую категорию номера в Вашей
              гостинице/квартире/доме?
            </Typography>
            <Typography variant='body1'>
              Найдите необходимый объект в списке и нажмите на кнопку
              "Смотреть/Изменить".
              <br />
              Перейдите в раздел "Номера" (нажмите на него меню)
              <br />
              Нажмите на кнопку "Добавить номер"
            </Typography>
          </div>
        </CardContent>
      </Card>
    );
    if (mobileAgent) {
      addBtn = <></>;
      helpText = (
        <Card className='card add-card card-object'>
          <CardContent>
            <div className='mb-3'>
              <Typography className='' variant='h6'>
                Как добавить новую гостиницу/квартиру/дом?
              </Typography>
              <Typography variant='body1'>
                Для того, чтобы добавить новую гостиницу/квартиру/дом нажмите на
                кнопку "Добавить новый объект"
              </Typography>
            </div>
            <div className='mb-3'>
              <Typography className='' variant='h6'>
                Как изменить информацию о гостинице/квартире/доме?
              </Typography>
              <Typography variant='body1'>
                Найдите необходимую гостиницу/квартиру/дом в списке Ваших
                объектов и нажмите на кнопку "Смотреть/Изменить"
              </Typography>
            </div>
            <div className='mb-3'>
              <Typography className='' variant='h6'>
                Как добавить новую категорию номера в Вашей
                гостинице/квартире/доме?
              </Typography>
              <Typography variant='body1'>
                Найдите необходимый объект в списке и нажмите на кнопку
                "Смотреть/Изменить".
                <br />
                Перейдите в раздел "Номера" (нажмите на него меню)
                <br />
                Нажмите на кнопку "Добавить номер"
              </Typography>
            </div>
          </CardContent>
        </Card>
      );
      mobileElements.push(
        <div className='add-card__wrp__mobile'>
          <Button
            className={`w-100 mb-2 btn ${buttons.btnWarn}`}
            onClick={handelClickGetAccess2Object}
          >
            <FontAwesomeIcon icon='question-circle' className='me-1' />
            Уже есть объект на Едем-в-Гости.ру?
          </Button>
          <Button
            className={`w-100 btn ${buttons.btnGreen}`}
            onClick={handelClickAddObject}
          >
            <FontAwesomeIcon icon='plus' className='me-1' />
            Добавить гостиницу/квартиру/дом
          </Button>
        </div>
      );
    } else {
      mobileElements = [];
    }
  }

  return (
    <>
      <div className='row cards-object row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4 mb-4'>
        {addBtn}
        {children}
        {mobileElements}
        <Modal
          btnOkAction={redirectToAddObject}
          show={confirmRedirectModal}
          fullScreen={mobileAgent}
          btnCancelAction={() => setConfirmRedirectModal(!confirmRedirectModal)}
          textBtnCancel={'Назад'}
          textBtnOk={'Добавить новую гостиницу/квартиру/дом'}
          title={'Внимание:'}
        >
          В Вашем личном кабинете уже есть гостиница/квартира/дом. Вы хотите
          добавить объект?
          <PreviewObjects objects={objects} />
        </Modal>
        <Modal
          btnOkAction={sendGetAccess2ObjectRequest}
          showBtnOk={userVirified == 'Y'}
          show={showGetAccess2ObjectModal}
          fullScreen={mobileAgent}
          btnCancelAction={() =>
            setShowGetAccess2ObjectModal(!showGetAccess2ObjectModal)
          }
          textBtnCancel={'Назад'}
          textBtnOk={'Отправить'}
          title={'Получить доступ к гостинице/квартире/дому'}
        >
          <Access2Object
            formRef={formRef}
            onSuccess={setShowGetAccess2ObjectModal}
          />
        </Modal>
      </div>
      {helpText}
    </>
  );
};

export default ObjectsTable;
